<template>
  <section class="container">
    <template v-if="parkData">
      <parking-search
        v-show="tab==0"
        :tab="tab"
        :parkList="parkList"
        :parkData="parkData"
        @parkSelect="parkSelect"
        :refush="refush"
      ></parking-search>
      <parking-record
        v-if="tab==1"
        :tab="tab"
        :parkHeaderId="parkData.id"
        :parkName="parkData.parkName"
      ></parking-record>
      <parking-coupon
        v-if="tab==2"
        :tab="tab"
        :parkHeaderId="parkData.id"
        :parkName="parkData.parkName"
        @couponClick="couponClick"
      ></parking-coupon>
    </template>
    <section class="tab_bottom border-top">
      <section
        :class="['bottom_item',tab==0?'cur':'',common.theme==1&&tab==0?'cur_2':'']"
        @click="navClick(0)"
      >
        <img
          :src="tab==0?require(`../../assets/images/icon_tab_pay_selected_${common.theme}.png`):require(`../../assets/images/icon_tab_pay_normal.png`)"
        />
        <span>停车缴费</span>
      </section>
      <section
        :class="['bottom_item',tab==1?'cur':'',common.theme==1&&tab==1?'cur_2':'']"
        @click="navClick(1)"
      >
        <img
          :src="tab==1?require(`../../assets/images/icon_tab_record_selected_${common.theme}.png`):require(`../../assets/images/icon_tab_record_normal.png`)"
        />
        <span>缴费记录</span>
      </section>
      <section
        :class="['bottom_item',tab==2?'cur':'',common.theme==1&&tab==2?'cur_2':'']"
        @click="navClick(2)"
      >
        <img
          :src="tab==2?require(`../../assets/images/icon_tab_coupon_selected_${common.theme}.png`):require(`../../assets/images/icon_tab_coupon_narmal.png`)"
        />
        <span>停车券</span>
      </section>
    </section>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { freeCall, getUserMarketInfo } from '../../utils/api'
import ParkingSearch from './components/parkingSearch'
import ParkingRecord from './components/parkingRecord'
import ParkingCoupon from './components/parkingCoupon'
import util from '../../utils/util'
import storage from '../../utils/storage'
 import wx from 'weixin-js-sdk'
//import wx from 'jweixin-1.6.0'
export default {
  name: 'parkingService',
  props: {},
  components: {
    ParkingSearch,
    ParkingRecord,
    ParkingCoupon
  },
  filters: {
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      parkData: '',
      licenseNumber: [],
      userSelect: '',
      parkList: [],
      gpsLatitude: '',//纬度
      gpslongitude: '',//经度
      tab: 0,
      refush: '',
    }
  },
  created() {
    if (this.$route.query.tab) {
      this.tab = Number(this.$route.query.tab);
    }
    let that = this;
    // 判断是否是业主地址进来
    if (this.$route.query.cityId) {
       console.log("in getLocation ready")
          wx.ready(()=>{
            console.log("in getLocation")
        wx.getLocation({
          type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function (res) {
            console.log(res)
            that.gpsLatitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
            that.gpslongitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
          },
          fail: function (res) {
            console.log(res)
          },
          complete: function () {
            that.queryParkHeaderList();
          }
        });
      })
      // this.queryParkHeaderList();
    } else {
      this.getParkName();
    }
  },
  activated() {
    this.getUserMarketInfo();

  },
  methods: {
    ...mapActions([
      "getBanerList",
      "getIndexStyle",
      "getActivityList",
      "getEmptyShopList",
      "getNoticeList",
      "getCompanyWallList",
      "getShopsList",
      "getMarketInfo",
      "getTheme",
      "getHolidayStyle",
      "getUserInfo",
      "getTenantInfo",
      "getTenantInfoList"
    ]),
    getUserMarketInfo() {
      getUserMarketInfo({}, { marketId: this.common.marketInfo.id }).then(res => {
        console.log(res)
        this.refush = res;
        if (res.res && res.res.code === 10000 && res.body) {

          if (res.body.tbMarketInfo) {
            this.getMarketInfo(res.body.tbMarketInfo);
            this.getTheme(res.body.tbMarketInfo.styleType);//设置全局主题色
            this.getHolidayStyle(res.body.tbMarketInfo.holidayStyle);//设置全局主题色
          }
          if (res.body.userInfo) {
            this.getUserInfo(res.body.userInfo);
          } else {
            this.getUserInfo({});
          }
          if (res.body.userTenantInfo) {
            this.getTenantInfo(res.body.userTenantInfo);
          } else {
            this.getTenantInfo({});
          }
          if (res.body.userTenantInfoList && res.body.userTenantInfoList.length) {
            this.getTenantInfoList(res.body.userTenantInfoList);
          } else {
            this.getTenantInfoList([])
          }
        }
      })
    },
    queryParkHeaderList() {
      util.showLoading()
      let that = this;
      let params = {
        companyId: this.$route.query.cityId,
        url: '/parking/rstParkHeader/queryParkHeaderList'
      }
      freeCall(params).then(res => {
        console.log(res)
        util.hideLoading()
        if (res.res.code === 10000 && res.body) {
          let dataList = res.body.data || [];
          dataList.forEach(item => {
            if (item.remarks) {
              item.remarks = item.remarks.replace(/\n/g, "<br/>").split("<br/>");
            }
          })
          this.parkData = dataList[0];
          let distance = util.distance(that.gpsLatitude, that.gpslongitude, dataList[0].latitude, dataList[0].longitude)
          dataList.forEach(item => {
            if (distance > util.distance(that.gpsLatitude, that.gpslongitude, item.latitude, item.longitude)) {
              distance = util.distance(that.gpsLatitude, that.gpslongitude, item.latitude, item.longitude);
              that.parkData = item;
            }
          })
          that.parkList = dataList;
        } else {
          util.showToast('获取车场列表失败')
          this.getParkName()
        }
      })
    },
    getParkName() {
      util.showLoading()
      let params = {
        subProjectId: this.common.marketInfo.id,
        url: '/parking/rstParkHeader/queryParkHeaderList'
      }
      freeCall(params).then(res => {
        console.log(res)
        util.hideLoading()
        if (res.res.code == 10000) {
          let data = res.body.data;
          let prkHeaderId = storage.get("prkHeaderId" + this.common.marketInfo.id) || '';//判断是否有停车场id(用户手动切了停车场,直接扫二维码获取停车券进来)
          data.forEach(item => {
            if (item.remarks) {
              item.remarks = item.remarks.replace(/\n/g, "<br/>").split("<br/>");
            }
            if (item.id == prkHeaderId || item.id == this.$route.query.prkHeaderId) {
              this.parkData = item;
            }
          })
          if (!prkHeaderId && !this.$route.query.prkHeaderId) {
            this.parkData = data[0];
          }
          // 地址栏没有带停车场id
          if (!this.$route.query.prkHeaderId) {
            this.parkList = data;
          } else {
            this.parkList = [];
          }
        } else {
          util.showToast("停车场获取失败");
        }
      });
    },
    navClick(val) {
      this.tab = val
    },
    couponClick() {
      this.tab = 0;
    },
    parkSelect(val) {
      this.parkList.forEach(item => {
        if (val === item.parkName) {
          this.parkData = item;
          // 一个项目多个停车场的情况,切换停车场记录缓存
          if (!this.$route.query.cityId) {
            storage.set("prkHeaderId" + this.common.marketInfo.id, item.id)
          }
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  // height:100vh;
}
.tab_bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 108px;
  z-index: 2;
  background: #fff;
  .flex();
  .bottom_item {
    flex: 1;
    .flex(column);
    justify-content: center;
    align-items: center;
    img {
      width: 48px;
      height: 48px;
      margin-bottom: 4px;
    }
    span {
      font-size: 24px;
      color: rgba(180, 190, 200, 1);
      line-height: 34px;
    }
  }
  .cur {
    span {
      color: #1740da;
    }
  }
  .cur_2 {
    span {
      color: #333333;
    }
  }
}
</style>
